import { useMemo } from "react";
import useAuth from "./useAuth";


const usePermissions = (menuName) => {
  const { user } = useAuth();

  return useMemo(() => {
    if (!user?.menus) return { add: 0, edit: 0, view: 0, delete: 0 };

    const menu = user.menus.find((m) => m.menuName === menuName);
    return menu ? menu.permissions : { add: 0, edit: 0, view: 0, delete: 0 };
  }, [user, menuName]);
};

export default usePermissions;
